import React, { useState, useEffect } from "react";
import "./Template_1.css";
import apiService from "../../Common/Configurations/APIService";
import config from "../../Common/Configurations/APIConfig";
import DefaultData from "../../CompanyData/DefaultData";

const Template_1_TravelTypes = () => {
  const [travelTypes, setTravelTypes] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const companyId = DefaultData.DEFAULTCOMPANYID;

  // Static mapping (icons + descriptions)
  const travelTypeMeta = {
    Honeymoon: {
      icon: "fa-solid fa-heart",
      description: "Romantic escapes for newlyweds",
    },
    Family: {
      icon: "fa-solid fa-users",
      description: "Fun-filled adventures for the whole family",
    },
    Pilgrims: {
      icon: "fa-solid fa-hands-praying",
      description: "Spiritual journeys to sacred places",
    },
    Corporate: {
      icon: "fa-solid fa-briefcase",
      description: "Business travel and corporate packages",
    },
    Group: {
      icon: "fa-solid fa-user-group",
      description: "Great deals for group adventures",
    },
  };

  // Helper: capitalize first letter, lowercase rest
  const formatTitle = (str) =>
    str ? str.charAt(0).toUpperCase() + str.slice(1).toLowerCase() : "";

  useEffect(() => {
    const GetTravelTypes = async () => {
      setIsLoading(true);
      try {
        const travelTypesResponse = await apiService.getAll(
          `${config.GETALLTRAVELTYPES}?companyId=${companyId}`
        );

        const mergedData = (travelTypesResponse || []).map((item) => {
          const formattedName = formatTitle(item.travelTypeName);

          const meta = travelTypeMeta[formattedName] || {};
          return {
            id: item.travelTypeId,
            title: formattedName,
            icon: meta.icon || "fa-solid fa-plane", // fallback
            description: meta.description || "Explore amazing journeys", // fallback
          };
        });

        setTravelTypes(mergedData);
      } catch (error) {
        console.error("Failed to fetch travel types:", error);
      } finally {
        setIsLoading(false);
      }
    };

    GetTravelTypes();
  }, [companyId]);

  return (
    <section className="Template_1 section Template_1 travel-types-section">
      <div className="Template_1 container">
        <div className="Template_1 section-title">
          <h2>Ways to Travel with Us</h2>
          <p>We offer specialized packages for every type of traveler</p>
        </div>

        {isLoading ? (
          <p>Loading travel types...</p>
        ) : (
          <div className="Template_1 travel-types">
            {travelTypes.map((type) => (
              <div key={type.id} className="Template_1 travel-type">
                <i className={type.icon}></i>
                <h3>{type.title}</h3>
                <p>{type.description}</p>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default Template_1_TravelTypes;
